import React from "react";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { alertStyles } from "./index.styles";

interface notification {
  message: string;
  notify: boolean;
  closeNotify: () => void;
  type: "success" | "info" | "warning" | "error";
  icon?: React.ReactNode;
}

const Notify = ({ message, notify, closeNotify, type, icon }: notification) => {
  const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  // constants
  const horizontal = "center";
  const vertical = "top";

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={notify}
      key={vertical + horizontal}
      onClose={closeNotify}
      autoHideDuration={2000}
    >
      <Alert
        icon={icon}
        onClose={closeNotify}
        sx={{ ...alertStyles, color: "#fff" }}
        severity={`${type}`}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notify;
